// TOTALLY NORMAL TOWN — boot. Order: CrazyGames SDK (if hosted) → profile → assets → the world → straight into a round
// (a first CrazyGames visit lands in gameplay with zero clicks; others see the door with one big PLAY).

import * as cg from "./platform/cg";
import * as fp from "./platform/fp";
import * as store from "./meta/store";
import { detectTier } from "./render/core";
import { World } from "./render/world";
import { json } from "./render/assets";
import { Game } from "./game";

const canvas = document.getElementById("stage") as HTMLCanvasElement;

async function boot() {
  if (new URLSearchParams(location.search).has("tiles")) {   // build tool: locker tiles via the game's renderer
    const { renderTiles } = await import("./qa/tiles");
    (window as any).TILES = await renderTiles(await json("./assets/manifest.json")); return;
  }
  await Promise.all([cg.ready, fp.ready]);            // the SDK must be initialised before loadingStart, or the call is a silent no-op
  cg.loadingStart();
  store.load();
  const man = await json("./assets/manifest.json").catch(() => ({}));
  const ui = await json("./assets/ui/manifest.json").catch(() => ({ frames: {} }));
  const tier = detectTier();
  const world = new World(canvas, tier, { ...man, fx: ui.fx ?? {} });
  const game = new Game(world, ui);
  await Promise.all([world.ready, game.ready]);
  cg.loadingStop();
  game.start();
  (window as any).TNT = { world, game, store };      // probes read this
  if (new URLSearchParams(location.search).has("director")) {   // store tool: covers + preview reel
    const { Director } = await import("./qa/director");
    const wait = () => new Promise((r) => setTimeout(r, 50));
    while (!game.feed || !(game.feed as any).net?.tr?.table) await wait();
    (window as any).DIR = new Director(game);
  }
}
boot().catch((e) => { console.error("[boot]", e); const d = document.createElement("pre"); d.style.cssText = "position:fixed;left:8px;bottom:8px;color:#3A2E2C;font:12px monospace;z-index:9"; d.textContent = "boot failed: " + (e?.message || e); document.body.append(d); });
